import {Vue} from "vue-property-decorator";
import Application from "@/state/Application";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import Notifications, {NotificationSettings} from "@/state/Notifications";

export function validate(component: Vue): Promise<boolean> {
    const resultArr = [component.$validator.validateAll()];
    if (component.$children.length != 0) {
        component.$children.map(child => validate(child)).forEach(result => resultArr.push(result))
    }
    return Promise.all(resultArr).then(boolArr => {
        let result = true;
        for (let i = 0; i < boolArr.length; i++) {
            result = result && boolArr[i];
        }
        return result;
    })
}

export function resetValidate(component: Vue): void {
    component.$validator.reset();
    if (component.$children.length !== 0) {
        component.$children.map(child => resetValidate(child));
    }
}

export function ifValid(component: Vue, success: () => void, error: () => void = function () {return;}): void {
    validate(component).then(
        isValid => isValid ? success() : error()
    )
}

export function processError(error: any, vue: Vue, options?: {
    settings?: NotificationSettings,
    callback?: () => void
}) {
    const data = error?.response?.data;
    const params = {
        ...(data?.params || {}),
        ...(typeof data?.param === 'object' ? data?.param : {param: data?.param})
    };
    Notifications.error(
        vue.$t(
            ErrorLocalePathUtils.getPathForError(error),
            params
        ) as string,
        options?.settings,
    )
    if (options?.callback) options.callback
    Application.stopLoading()
}
